import type { Transition } from 'motion/react';

/**
 * Shared-layout identity tying the exit ticket's two banner states together.
 *
 * The full-width invitation (DashboardExitSlipBanner) and the corner result card
 * (DashboardExitSlipCollapsedBanner) are separate components that never render at the same time.
 * Tagging both with this `layoutId` is what turns the swap into a morph: Motion measures the
 * outgoing banner's box, mounts the card at that box and animates it down to the bottom-right
 * corner, so the wide banner reads as shrinking and travelling into the card.
 *
 * It only works because the swap lands in a single commit — DashboardExitSlipModal's
 * `closeAfterFinished` closes the modal, flips the redux "finished" flag and stores the outcome in
 * one batched handler, so Motion sees the old element unmount and the new one mount together. Split
 * those across two renders and the banner would blink out before the card appears, with no morph.
 */
export const EXIT_SLIP_BANNER_LAYOUT_ID = 'exit-slip-banner';

/** The collapse morph. Eased out so the card decelerates into the corner instead of snapping. */
export const EXIT_SLIP_BANNER_TRANSITION: Transition = { duration: 0.45, ease: [0.2, 0.8, 0.2, 1] };

/**
 * The 16px radius both banners paint (`--border-radius-rounded-2xl`), applied inline rather than
 * left to the stylesheet: Motion drives the morph with a scale transform and can only counter-scale
 * `borderRadius` when it owns the value, so a class-only radius would smear during the animation.
 */
export const EXIT_SLIP_BANNER_RADIUS = 16;
